<template>
  <div class="page-container">
    <div class="toolbar">
      <div class="actions">
        <el-button type="primary" @click="openModal">新建合同</el-button>
        <el-button @click="handleExport">导出Excel</el-button>
        <el-button @click="triggerImport">导入Excel</el-button>
        <input ref="importInput" type="file" accept=".xlsx,.xls" style="display:none" @change="onImportFile" />
      </div>
      <div class="filters">
        <el-input v-model="query.contractName" placeholder="合同名称" clearable style="width: 180px" @keyup.enter="loadContracts" />
        <el-select v-model="query.grainStoreId" placeholder="所属粮库" clearable filterable style="width: 180px" @change="loadContracts">
          <el-option v-for="s in storeOptions" :key="s.id" :label="s.storeName" :value="s.id" />
        </el-select>
        <el-select v-model="query.manageStatus" placeholder="管理状态" clearable style="width: 130px" @change="loadContracts">
          <el-option label="全部" value="" />
          <el-option label="执行中" :value="1" />
          <el-option label="已终止" :value="2" />
          <el-option label="已完成" :value="3" />
          <el-option label="已续签" :value="4" />
        </el-select>
        <el-select v-model="query.status" placeholder="执行情况" clearable style="width: 130px" @change="loadContracts">
          <el-option label="全部" value="" />
          <el-option label="已终止" value="terminated" />
          <el-option label="已到期" value="expired" />
          <el-option label="30天内到期" value="soon" />
          <el-option label="正常" value="normal" />
        </el-select>
        <el-button type="primary" @click="loadContracts">查询</el-button>
        <el-button @click="resetQuery">重置</el-button>
      </div>
    </div>

    <el-table :data="contracts" border stripe>
      <el-table-column prop="contractNo" label="合同编号" width="120" />
      <el-table-column prop="contractName" label="合同名称" min-width="140" />
      <el-table-column prop="grainStoreName" label="所属粮库" min-width="120" />
      <el-table-column prop="partyA" label="甲方" min-width="100" />
      <el-table-column prop="partyB" label="乙方" min-width="100" />
      <el-table-column prop="amount" label="合同金额(元)" width="120" />
      <el-table-column label="开始日期" width="110">
        <template #default="scope">{{ formatDate(scope.row.startDate) }}</template>
      </el-table-column>
      <el-table-column label="结束日期" width="110">
        <template #default="scope">{{ formatDate(scope.row.endDate) }}</template>
      </el-table-column>
      <el-table-column label="管理状态" width="96">
        <template #default="scope">
          <el-tag :type="manageTag(scope.row).type" size="small">{{ manageTag(scope.row).text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="执行情况" width="110">
        <template #default="scope">
          <el-tag :type="execTag(scope.row).type" size="small">{{ execTag(scope.row).text }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150" fixed="right">
        <template #default="scope">
          <el-button size="small" @click="editContract(scope.row)">编辑</el-button>
          <el-button size="small" type="danger" @click="handleDeleteContract(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <MyPager :total="total" v-model:page="pageNum" v-model:size="pageSize" @change="loadContracts" />

    <el-dialog :title="formData.id ? '编辑合同' : '新建合同'" v-model="dialogVisible" width="640px">
      <el-form :model="formData" label-width="100px">
        <el-form-item label="合同编号">
          <el-input v-model="formData.contractNo" placeholder="如 HT-2026-001" />
        </el-form-item>
        <el-form-item label="合同名称">
          <el-input v-model="formData.contractName" />
        </el-form-item>
        <el-form-item label="所属粮库" required>
          <el-select v-model="formData.grainStoreId" placeholder="请选择粮库" filterable style="width: 100%">
            <el-option v-for="s in storeOptions" :key="s.id" :label="s.storeName" :value="s.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="甲方">
          <el-input v-model="formData.partyA" />
        </el-form-item>
        <el-form-item label="乙方">
          <el-input v-model="formData.partyB" />
        </el-form-item>
        <el-form-item label="合同金额">
          <el-input v-model="formData.amount" type="number" />
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker v-model="formData.startDate" type="date" value-format="YYYY-MM-DD" />
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker v-model="formData.endDate" type="date" value-format="YYYY-MM-DD" />
        </el-form-item>
        <el-form-item label="管理状态">
          <el-radio-group v-model="formData.status">
            <el-radio :value="1">执行中</el-radio>
            <el-radio :value="2">已终止</el-radio>
            <el-radio :value="3">已完成</el-radio>
            <el-radio :value="4">已续签</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="中止原因" v-if="formData.status === 2">
          <el-input v-model="formData.terminateReason" type="textarea" :rows="3" placeholder="请填写合同中途停止的原因" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveContract">确定</el-button>
      </template>
    </el-dialog>

    <el-dialog title="导入校验未通过" v-model="errorDialogVisible" width="580px" :close-on-click-modal="false">
      <div class="import-err-tip">
        共发现 <b style="color:#f56c6c">{{ importErrors.length }}</b> 处不合规数据，导入已终止。请按下列明细修改 Excel 后重新导入：
      </div>
      <ul class="import-err-list">
        <li v-for="(item, idx) in importErrors" :key="idx">{{ idx + 1 }}. {{ item }}</li>
      </ul>
      <template #footer>
        <el-button type="primary" @click="errorDialogVisible = false">我知道了，去修改</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import * as XLSX from 'xlsx'
import { getContractListPage, saveContract, deleteContract, getGrainStoreList, importContracts } from '../api'
import { formatDate } from '../utils/format'
import MyPager from '../components/MyPager.vue'

const contracts = ref([])
const storeOptions = ref([])
const pageNum = ref(1)
const pageSize = ref(20)
const total = ref(0)
const dialogVisible = ref(false)
const importInput = ref(null)
const errorDialogVisible = ref(false)
const importErrors = ref([])
const query = reactive({ contractName: '', grainStoreId: '', manageStatus: '', status: '' })
const formData = reactive({
  id: null,
  contractNo: '',
  contractName: '',
  grainStoreId: '',
  partyA: '',
  partyB: '',
  amount: 0,
  startDate: '',
  endDate: '',
  status: 1,
  terminateReason: ''
})

const DAY_MS = 24 * 60 * 60 * 1000

// 管理状态：1执行中 2已终止 3已完成 4已续签
const manageTag = (row) => {
  const map = {
    1: { type: 'success', text: '执行中' },
    2: { type: 'danger', text: '已终止' },
    3: { type: 'info', text: '已完成' },
    4: { type: 'primary', text: '已续签' }
  }
  return map[row.status] || map[1]
}

// 执行情况：终态直接显示终态；执行中按到期日临期提醒
const execTag = (row) => {
  if (row.status === 2) return { type: 'danger', text: '已终止' }
  if (row.status === 3) return { type: 'info', text: '已完成' }
  if (row.status === 4) return { type: 'primary', text: '已续签' }
  if (!row.endDate) return { type: 'success', text: '正常' }
  const end = new Date(row.endDate).getTime()
  const days = (end - Date.now()) / DAY_MS
  if (days < 0) return { type: 'warning', text: '已到期' }
  if (days <= 30) return { type: 'warning', text: '30天内到期' }
  return { type: 'success', text: '正常' }
}

const statusTextOf = (s) => ({ 1: '执行中', 2: '已终止', 3: '已完成', 4: '已续签' }[s] || '执行中')

onMounted(() => {
  loadStores()
  loadContracts()
})

const loadStores = async () => {
  try {
    const res = await getGrainStoreList()
    storeOptions.value = res.data || []
  } catch (e) { /* 忽略 */ }
}

const buildQueryParams = () => {
  const params = { page: pageNum.value, size: pageSize.value }
  if (query.contractName) params.contractName = query.contractName
  if (query.grainStoreId) params.grainStoreId = query.grainStoreId
  if (query.manageStatus) params.manageStatus = query.manageStatus
  if (query.status) params.status = query.status
  return params
}

const loadContracts = async () => {
  try {
    const res = await getContractListPage(buildQueryParams())
    contracts.value = res.data?.list || []
    total.value = res.data?.total || 0
  } catch (error) {
    ElMessage.error('加载合同失败')
  }
}

const resetQuery = () => {
  query.contractName = ''
  query.grainStoreId = ''
  query.manageStatus = ''
  query.status = ''
  pageNum.value = 1
  loadContracts()
}

const openModal = () => {
  Object.assign(formData, {
    id: null, contractNo: '', contractName: '', grainStoreId: '', partyA: '', partyB: '',
    amount: 0, startDate: '', endDate: '', status: 1, terminateReason: ''
  })
  dialogVisible.value = true
}

const editContract = (row) => {
  Object.assign(formData, {
    id: row.id,
    contractNo: row.contractNo,
    contractName: row.contractName,
    grainStoreId: row.grainStoreId,
    partyA: row.partyA,
    partyB: row.partyB,
    amount: row.amount,
    startDate: row.startDate,
    endDate: row.endDate,
    status: row.status || 1,
    terminateReason: row.terminateReason || ''
  })
  dialogVisible.value = true
}

const handleSaveContract = async () => {
  if (!formData.grainStoreId) {
    ElMessage.warning('请选择所属粮库')
    return
  }
  if (formData.status === 2 && !formData.terminateReason) {
    ElMessage.warning('已终止合同请填写中止原因')
    return
  }
  try {
    await saveContract(formData)
    ElMessage.success('保存成功')
    dialogVisible.value = false
    loadContracts()
  } catch (error) {
    ElMessage.error('保存失败')
  }
}

const handleDeleteContract = async (id) => {
  try {
    await deleteContract(id)
    ElMessage.success('删除成功')
    loadContracts()
  } catch (error) {
    ElMessage.error('删除失败')
  }
}

// ===== Excel 全量导出 =====
const handleExport = async () => {
  try {
    const hasFilter = !!(query.contractName || query.grainStoreId || query.manageStatus || query.status)
    if (hasFilter) {
      try {
        await ElMessageBox.confirm(
          '当前已设置筛选条件，导出的是筛选后的部分合同。\n若后续据此导入，文件中不存在的合同（被筛掉的那些）会被删除。\n建议重置筛选后导出完整清单再做覆盖导入。\n\n仍要导出当前筛选结果吗？',
          '导出为部分清单',
          { type: 'warning', confirmButtonText: '仍要导出', cancelButtonText: '取消' }
        )
      } catch (cancel) {
        ElMessage.info('已取消导出')
        return
      }
    }
    const res = await getContractList(buildQueryParams())
    const rows = res.data || []
    const headers = ['合同编号', '合同名称', '所属粮库', '甲方', '乙方', '合同金额(元)', '开始日期', '结束日期', '合同状态', '中止原因']
    const aoa = [headers]
    rows.forEach(r => {
      aoa.push([
        r.contractNo || '',
        r.contractName || '',
        r.grainStoreName || '',
        r.partyA || '',
        r.partyB || '',
        r.amount != null ? r.amount : '',
        formatDate(r.startDate),
        formatDate(r.endDate),
        statusTextOf(r.status),
        r.terminateReason || ''
      ])
    })
    const ws = XLSX.utils.aoa_to_sheet(aoa)
    ws['!cols'] = headers.map(h => ({ wch: Math.min(40, Math.max(10, h.length * 2)) }))
    const wb = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(wb, ws, '合同')
    const d = new Date()
    const pad = n => String(n).padStart(2, '0')
    const name = '合同列表_' + d.getFullYear() + pad(d.getMonth() + 1) + pad(d.getDate()) + '.xlsx'
    XLSX.writeFile(wb, name)
    ElMessage.success('导出成功，共 ' + rows.length + ' 条')
  } catch (e) {
    ElMessage.error('导出失败')
  }
}

// ===== Excel 导入 =====
const triggerImport = () => {
  if (importInput.value) importInput.value.click()
}

const normalizeDate = (v) => {
  if (v == null || v === '') return null
  if (typeof v === 'number') {
    // Excel 日期序列号（1900 日期系统）
    const d = new Date(Math.round((v - 25569) * 86400 * 1000))
    if (isNaN(d.getTime())) return null
    const p = n => String(n).padStart(2, '0')
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
  }
  if (v instanceof Date) {
    const p = n => String(n).padStart(2, '0')
    return v.getFullYear() + '-' + p(v.getMonth() + 1) + '-' + p(v.getDate())
  }
  const s = String(v).trim()
  if (/^\d{4}-\d{1,2}-\d{1,2}/.test(s)) return s.slice(0, 10)
  const d = new Date(s)
  if (!isNaN(d.getTime())) {
    const p = n => String(n).padStart(2, '0')
    return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
  }
  return null
}

const onImportFile = (e) => {
  const file = e.target.files && e.target.files[0]
  if (!file) return
  const reader = new FileReader()
  reader.onload = async (ev) => {
    try {
      const data = new Uint8Array(ev.target.result)
      const wb = XLSX.read(data, { type: 'array', cellDates: true })
      const ws = wb.Sheets[wb.SheetNames[0]]
      const json = XLSX.utils.sheet_to_json(ws, { raw: false, defval: '' })
      if (!json.length) {
        ElMessage.error('文件中没有可识别的数据行')
        e.target.value = ''
        return
      }
      const errors = []
      const list = []
      const seenNos = new Set()
      json.forEach((row, i) => {
        const lineNo = i + 2 // Excel 第 2 行起为数据
        const storeName = String(row['所属粮库'] || '').trim()
        const contractNo = String(row['合同编号'] || '').trim()
        const contractName = String(row['合同名称'] || '').trim()
        const statusRaw = String(row['合同状态'] || '').trim()
        const store = storeOptions.value.find(s => String(s.storeName || '').trim() === storeName)
        if (!storeName) errors.push(`第${lineNo}行：所属粮库为空`)
        else if (!store) errors.push(`第${lineNo}行：所属粮库「${storeName}」在系统中不存在`)
        if (!contractNo) errors.push(`第${lineNo}行：合同编号为空`)
        else if (seenNos.has(contractNo)) errors.push(`第${lineNo}行：合同编号「${contractNo}」在文件中重复`)
        else seenNos.add(contractNo)
        if (!contractName) errors.push(`第${lineNo}行：合同名称为空`)
        let status
        if (statusRaw === '已终止' || statusRaw === '2') status = 2
        else if (statusRaw === '已完成' || statusRaw === '3') status = 3
        else if (statusRaw === '已续签' || statusRaw === '4') status = 4
        else if (statusRaw === '执行中' || statusRaw === '1' || statusRaw === '') status = 1
        else { errors.push(`第${lineNo}行：合同状态「${statusRaw}」不合法，应为"执行中/已终止/已完成/已续签"`); status = 1 }
        const start = normalizeDate(row['开始日期'])
        const end = normalizeDate(row['结束日期'])
        if (row['开始日期'] != null && row['开始日期'] !== '' && !start) errors.push(`第${lineNo}行：开始日期格式无效（应为 yyyy-MM-dd）`)
        if (row['结束日期'] != null && row['结束日期'] !== '' && !end) errors.push(`第${lineNo}行：结束日期格式无效（应为 yyyy-MM-dd）`)
        if (start && end && start > end) errors.push(`第${lineNo}行：开始日期晚于结束日期`)
        const amountRaw = row['合同金额(元)']
        let amount = null
        if (amountRaw !== '' && amountRaw != null) {
          amount = Number(amountRaw)
          if (isNaN(amount)) errors.push(`第${lineNo}行：合同金额「${amountRaw}」不是有效数字`)
        }
        const terminateReason = (status === 2) ? String(row['中止原因'] || '').trim() : null
        if (status === 2 && !terminateReason) errors.push(`第${lineNo}行：已终止合同缺少中止原因`)
        list.push({
          contractNo,
          contractName,
          grainStoreId: store ? store.id : null,
          partyA: String(row['甲方'] || '').trim(),
          partyB: String(row['乙方'] || '').trim(),
          amount: (amountRaw === '' || amountRaw == null) ? null : (isNaN(amount) ? null : amount),
          startDate: start,
          endDate: end,
          status,
          terminateReason
        })
      })
      // 存在不合规数据：整体拒绝导入，弹明细让用户修改后重导
      if (errors.length) {
        importErrors.value = errors
        errorDialogVisible.value = true
        e.target.value = ''
        return
      }
      try {
        await ElMessageBox.confirm(
          '导入将按照文件内容【全量覆盖】现有合同：\n• 文件中存在的合同将新增或更新\n• 文件中不存在的合同将被删除（含你手动删掉的行）\n\n请确认你导入的是完整合同清单，是否继续？',
          '全量导入确认',
          { type: 'warning', confirmButtonText: '确认覆盖', cancelButtonText: '取消' }
        )
      } catch (cancel) {
        ElMessage.info('已取消导入')
        e.target.value = ''
        return
      }
      const res = await importContracts(list)
      const msg = (res && res.message) || '导入成功'
      ElMessage.success(msg)
      loadContracts()
    } catch (err) {
      ElMessage.error('导入失败：' + (err && err.message ? err.message : err))
    } finally {
      e.target.value = ''
    }
  }
  reader.onerror = () => {
    ElMessage.error('读取文件失败')
    e.target.value = ''
  }
  reader.readAsArrayBuffer(file)
}
</script>

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 10px;
}
.actions,
.filters {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.import-err-tip {
  font-size: 14px;
  color: #606266;
  margin-bottom: 10px;
  line-height: 1.6;
}
.import-err-list {
  max-height: 320px;
  overflow-y: auto;
  margin: 0;
  padding-left: 20px;
  color: #303133;
  font-size: 13px;
  line-height: 1.9;
}
.import-err-list li {
  list-style: decimal;
}
</style>
